export const lightCommonVariables = {
  token: {
    colorBgContainer: '#fff',
    colorBgBase: '#fff',
    colorText: '#4E5B6A',
    colorWhite: '#fff'
  },
  components: {
    Button: {
      colorBorder: '#f1f1f0'
    },
    Checkbox: {
      colorBgContainer: '#fff',
      colorBorder: '#d9d9d9',
      colorWhite: 'white'
    },
    Collapse: {
      colorTextHeading: '#000',
      collapseContentBg: '#fff' // doesn't take effect
    },
    ColorPicker: {
      colorBorder: '#E7E7E6' // --button-default-border
    },
    DatePicker: {
      colorBorder: '#E7E7E6',
      colorTextDisabled: 'rgba(0, 0, 0, 0.25)'
    },
    Drawer: {
      colorBgElevated: '#fff',
      colorTextDisabled: 'rgba(0, 0, 0, 0.25)'
    },
    Form: {
      colorTextHeading: '#000'
    },
    Input: {
      colorBgContainer: '#fff', // (--body-background)
      colorBorder: '#E7E7E6', // --button-default-border
      colorText: '#4E5B6A'
    },
    InputNumber: {
      colorBgContainer: '#fff', // (--body-background)
      colorBorder: '#E7E7E6'
    },
    Modal: {
      colorTextHeading: '#000', // doesn't take effect
      modalContentBg: '#fff' // doesn't take effect
    },
    Radio: {
      colorBorder: '#E7E7E6'
    },
    Select: {
      colorBorder: '#E7E7E6',
      colorText: '#000',
      controlItemBgActive: 'rgba(78, 116, 252, 0.1)'
    },
    Slider: {
      colorText: '#4E5B6A'
    },
    Switch: {
      colorTextQuaternary: 'rgba(0, 0, 0, 0.25)'
    },
    // Table: {
    //   tableFooterBg: '#fff',
    //   tableHeaderBg: '',
    //   tableHeaderTextColor: '',
    //   tablePaddingVertical: '',
    // tablePaddingHorizontal: '',
    // },
    Tabs: {
      colorSplit: '#E7E7E6',
      tabsCardHeadBackground: '#fafafa !important' // doesn't take effect
    },
    Tag: {
      tagDefaultColor: '#4E5B6A'
    },
    Tooltip: {
      // tooltipBg: 'rgba(0, 0, 0, 0.75)'
    }
  }
};
